import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * Cinematic page header used on Voxcanon pages — eyebrow overline,
 * two-clause Cinzel display heading with the second clause carrying
 * the brand's auto-themed arcane → sienna gradient, optional Nunito
 * subline, and a right-aligned action slot.
 *
 * Lexicanon pages keep their own (denser) title pattern; if you want
 * to use this component there too, it's not gated by product, but the
 * Cinzel font + the gradient class assume the Voxcanon visual voice.
 */
export const VoxPageTitle = ({ eyebrow, leading, accent, subline, actions }: IProps): React.JSX.Element => {
  return (
    <div className={classes.root}>
      <div className={classes.headRow}>
        <div className={classes.headBlock}>
          {eyebrow && (
            <div className={classes.eyebrow}>
              <span className={classes.eyebrowDot} />
              <span>{eyebrow.primary}</span>
              {eyebrow.secondary && (
                <>
                  <span className={classes.eyebrowSep}>·</span>
                  <span>{eyebrow.secondary}</span>
                </>
              )}
            </div>
          )}
          <h1 className={classes.heading}>
            <span>{leading}</span>
            <span className={classes.accent}>{accent}</span>
          </h1>
          {subline && <p className={classes.subline}>{subline}</p>}
        </div>
        {actions && <div className={classes.actions}>{actions}</div>}
      </div>
    </div>
  )
}
